import React from "react";

/**
 * Inline "this player is on your avoid list" strip.
 *
 * WARN, NEVER BLOCK. This is a passive strip rendered next to the action, not a
 * modal or a confirm — it must never add a click to the bid/nominate flow, and
 * it never disables the button it sits above. Nothing here touches the engine.
 *
 * Props:
 *   name   — player name to check (usually the player on the block)
 *   avoids — Set of avoided player names (may be undefined → renders nothing)
 *   style  — layout overrides for the call site (margins, etc.)
 */
export default function AvoidWarning({ name, avoids, style }) {
  if (!name || !avoids?.has(name)) return null;
  return (
    <div
      style={{
        display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
        padding: "6px 10px", borderRadius: 8,
        background: "rgba(239,68,68,0.08)",
        border: "1px solid rgba(239,68,68,0.25)",
        color: "#ef4444", fontSize: 11, fontWeight: 700, letterSpacing: "0.3px",
        fontFamily: "inherit", lineHeight: 1.2,
        ...style,
      }}
    >
      <span style={{ fontSize: 12, lineHeight: 1 }}>{"🚫"}</span>
      <span>On your avoid list</span>
    </div>
  );
}
